import { useForm } from 'antd/lib/form/Form';
import { useState } from 'react';
import { addProductionCalendarDate } from 'services/api';
import type { DateFormValues } from '../../types';

interface UseCreateDateServiceProps {
  hide: () => void;
  onItemCreate: () => void;
}

export const useCreateDateService = ({ hide, onItemCreate }: UseCreateDateServiceProps) => {
  const [form] = useForm<DateFormValues>();
  const [loading, setLoading] = useState(false);

  const hideModal = () => {
    hide();
    form.resetFields();
  };

  const onSubmit = () => {
    form.validateFields().then((values) => {
      setLoading(true);
      addProductionCalendarDate({
        holiday: values.holiday === 'true',
        date: values.date.format('YYYY-MM-DD'),
        description: values.description,
      })
        .then(() => {
          hideModal();
          onItemCreate();
        })
        .finally(() => {
          setLoading(false);
        });
    });
  };

  return {
    state: { form, loading },
    methods: { hideModal, onSubmit },
  };
};
